// ESLint Settings
/* eslint no-console: "off", complexity: "off" */
/* globals page_data: true */

/**
*
* jQuery Estee Lauder products plugin
*
*   A jQuery plugin to populate content based on the presence of a template or non-templated product carousel.
*
* @version 2.0.3.6
* @author Stephen Tetreault <stephen.tetreault@firefallpro.com>, Aric Ng <aric@firefall.io>
* @link http://www.firefallpro.com/
* @license http://www.firefallpro.com/license.txt
* @copyright Copyright (c) 2015 Firefall Pro, LLC
*
* What's new in 2.0.3.6
* Narrowed the scope of where to search for templates
*
* 2.0.3.5
* Minor updates
*
*2.0.3.4
* Updated standard for loops to use forEach and swapped object iteration to use Object.keys()
*
* 2.0.3.3
* Fixed issues with targetting specific elements for product ID extraction and data population
*
* 2.0.3.2
* Improved product data handling. Enabled developer supplied product ids.
*
* 2.0.3.1
* Added productData injection options per element for legacy functionality
*
* 2.0.3
* Improved element targeting and handling
*
* 2.0.2.3
* Updated template search to respect current context
*
* 2.0.2.2:
* Updated data() handling so script works better with dynamically created elements
* Unit Price Handling
*
* 2.0.2.1:
* Complete usage of productMap object over array iteration
*
*/
(function($) {
  'use strict';

  /**
  * This is the object that holds all the methods used in $.fn.elproduct and $.fn.elproduct.query
  * @namespace $.fn.elproduct.methods
  */
  var methods = {
    /**
    *
    * Execute query to get RPC data
    *
    * @memberof $.fn.elproduct.methods
    * @function _query
    * @param {object} extended_object Holds the non-serialized JSON for the RPC query. If undefined use the JSON query created through _fetch_products.
    * @param {object} Options for this query function, which should contain a callback or flag.
    * @returns {object} Returns the Promise that holds the async call.
    *
    */
    '_query': function(extended_object) {
      var promise;

      // add product IDs to the Query's product array
      extended_object.query[0].params[0].products = Object.keys(extended_object.productMap);

      // notify
      if (extended_object.debug) {
        console.log('_query() function');
        console.log(extended_object.rpc_url + JSON.stringify(extended_object.query));
      }

      // set up promise
      promise = $.getJSON(extended_object.rpc_url + JSON.stringify(extended_object.query));

      // if the query fails, notify us.
      promise.fail(function() {
        if (extended_object.debug) {
          console.error('RPC Query has failed.');
        }

        if (typeof extended_object.onError !== 'undefined') {
          extended_object.onError();
        }

        return;
      }).done(function(data) {
        // if the query is done, sometimes it returns with an error. Notify us.
        // if the query truly succeeds, run _post_query_insertion().
        if (typeof data === 'undefined' || data[0].hasOwnProperty('error')) {
          if (extended_object.debug) {
            console.error('RPC Query has returned with an error.');
          }

          if (typeof extended_object.onError !== 'undefined') {
            extended_object.onError();
          }

          return;
        } else {
          methods._post_query_insertion(extended_object, data);
        }
      });
    },
    /**
    *
    * The RPC query has succeeded, we want to now inject content into our carousel.
    *
    * @memberof $.fn.elproduct.methods
    * @function _handle_rpc_write_success
    * @param {object} extended_object Holds the non-serialized JSON for the RPC query. If undefined use the JSON query created through _fetch_products.
    * @param {object} data - Represents the returned JSON object from the RPC query.
    * @returns {undefined}
    */
    '_post_query_insertion': function(extended_object, data) {
      // DOM
      var $targets = [];
      var products = data[0].result.value.products; // Products received from API
      var productID;

      // notify
      if (extended_object.debug) {
        console.log('_post_query_insertion() function');
        console.log('products', extended_object.productMap);
      }

      // if no data returned somehow (which can happen) then we return
      if (data[0].result.value === null) {
        if (extended_object.debug) {
          console.error('ERROR: Products array is null, returning now.');
        }

        extended_object.onError();

        return;
      }

      // Assign product data
      products.forEach(function(product) {
        productID = product.PRODUCT_ID;

        if (typeof extended_object.productMap[productID] !== 'undefined') {
          // Set base product data to inject
          extended_object.productMap[productID] = product;

          // Populate SKU map
          product.skus.forEach(function(sku) {
            extended_object.productMap[productID][sku.SKU_ID] = sku;
          });
        }
      });

      $targets = extended_object.wrappers.find(extended_object.target);

      // Inject results
      $targets.each(function() {
        // DOM
        var $this = $(this);
        var $element;
        // LOGIC
        var productData;
        var skuData;
        var productProperty;
        var targets;
        var productID = $this.attr('data-product');
        var skuID = $this.attr('data-sku');
        var modifier;

        // Skip invalid product IDs
        if (typeof productID === 'undefined') {
          return;
        }

        productData = extended_object.productMap[productID];

        // Product ID not found
        if (typeof productData === 'undefined' || Object.keys(productData).length === 0) {
          return;
        }

        // Use first SKU if skuID is empty
        skuData = (typeof skuID !== 'undefined' && skuID.trim().length !== 0) && typeof productID[skuID] === 'object' ? productID[skuID] : productData.skus[0];

        // Store product data for quickshop functionality
        $this.data('product-data', productData);
        // Apply product data for all a tags, these elements are clickable and are oft expected to do quickshop functionality
        $this.find('a').data('product-data', productData);

        // Legacy product data
        $this.data('full_product_json', productData);
        // Apply product data for all a tags, these elements are clickable and are oft expected to do quickshop functionality
        $this.find('a').data('full_product_json', productData);

        // Set (additional) standard attributes
        $this.attr('data-category-id', productData.DEFAULT_CAT_ID);

        // Iterate over productData
        Object.keys(extended_object.map).forEach(function(prop) {
          // Array is expected
          extended_object.map[prop].forEach(function(propertyData) {
            $element = $this.find(propertyData.selector);
            targets = propertyData.targets;
            modifier = propertyData.modifier;
            productProperty = productData[prop];

            // Must have available elements and element targets
            if ($element.length === 0 || targets.length === 0) {
              return;
            }

            // If product property doesn't exist, look into the sku
            // If that fails, skip property
            if (typeof productProperty === 'undefined' && typeof skuData !== 'undefined') {
              if (typeof skuData[prop] !== 'undefined') {
                productProperty = skuData[prop];
              } else {
                return;
              }
            // Skip property if there's no productProperty and skuData
            } else if (typeof productProperty === 'undefined' && typeof skuData === 'undefined') {
              return;
            }

            // product properties are usually a primitive type
            // If an array is encountered, use the first element (typically these are for image links)
            if (productProperty instanceof Array) {
              productProperty = productProperty[0];
            }

            if (typeof modifier === 'function') {
              productProperty = modifier(productProperty);
            }

            // Populate targets
            targets.forEach(function(target) {
              // Populate target element HTML immediately
              if (target === 'html') {
                $element.html(productProperty);
              // Otherwise populate attributes only if attribute exists on element
              } else if ($element.attr(target) !== null) {
                $element.attr(target, productProperty);
              }
            });
          });
        });
      });

      // call back
      if (typeof extended_object.onSuccess === 'function') {
        extended_object.onSuccess();
      }
    },

    '_generate_product_list': function(wrappers, extended_object) {
      // Adds productIDs to the productMap to populate later
      function processElProduct() {
        var $this = $(this);
        var productID;

        if (typeof $this.data('product') !== 'undefined') {
          productID = $this.data('product');

          // Mark product existence in the productMap
          if (productID.length !== 0 && typeof extended_object.productMap[productID] === 'undefined') {
            extended_object.productMap[productID] = {};
          }
        }
      }

      // iterate through wrappers
      wrappers.find(extended_object.target).each(processElProduct);

      // notify
      if (extended_object.debug) {
        console.log('_generate_product_list: product map: ', extended_object.productMap);
      }
    },
    /**
    *
    * Clone the li template as many times as there are products per that wrapper.
    *
    * @memberof $.fn.elproduct.methods
    * @function _create_list_items
    * @param {object} extended_object Holds the non-serialized JSON for the RPC query. If undefined use the JSON query created through _fetch_products.
    * @returns {undefined};
    */
    '_create_list_items': function(extended_object) {
      // iterate through wrappers containing el-product elements
      extended_object.wrappers.each(function() {
        // DOM
        var $this_wrapper = $(this);
        var $template = $this_wrapper.find(extended_object.template);
        var $this_ul = $this_wrapper.find('ul');
        // LOGIC
        var this_product_list = $this_wrapper.find(typeof extended_object.products !== 'undefined' ? extended_object.products : '.el-product_id-list').text().split(',').filter(function(element) {
          return element.trim().length !== 0;
        });

        // notify
        if (extended_object.debug) {
          console.log('_create_list_items() function');
          console.log('target ', $this_wrapper);
          console.log('extended object ', extended_object);
          console.log('template ', $template);
        }

        // if we have li's present in the wrapper then we skip cloning elements into it
        if ($this_ul.find('li').length > 0) {
          if (extended_object.debug) {
            console.log('<li>  found inside ' + $this_wrapper.attr('id') + ' so we skip cloning elements inside it.');
          }
        } else {
          // if we dont have li's present in the wrapper then we clone elements into it.
          // iterate through # of items per wrapper, making an <li> for each.
          this_product_list.forEach(function(ids) {
            // DOM
            var $cloned_template = $template.clone(true);
            var $cloned_template_shop_button = $cloned_template.find('.el-product_shop-now');
            // LOGIC
            var productID;
            var skuID;

            ids = ids.split(' ');
            productID = ids[0];
            skuID = ids.length > 1 ? ids[1] : undefined;

            // update prod and sku attributes on the cloned element, append it to the current wrapper
            if (productID.length !== 0) {
              $cloned_template.attr('data-product', productID); //.attr('data-sku', (ids.length < 2 ) ? '' : ids[1]);
              $cloned_template_shop_button.attr('data-product', productID); //.attr('data-sku', (ids.length < 2 ) ? '' : ids[1]);

              if (typeof skuID !== 'undefined' && skuID.length !== 0) {
                $cloned_template.attr('data-sku', skuID);
                $cloned_template_shop_button.attr('data-sku', skuID);
              }

              if (productID.length !== 0 && typeof extended_object.productMap[productID] === 'undefined') {
                extended_object.productMap[productID] = {};
              }
            }

            $this_ul.append($cloned_template);
          });
        }
      });
    }
  };

  $.fn.elproduct = function() {
    var extended_object;
    var settings = {};
    var $targets = typeof this === 'function' ? $('body') : $(this); // If we don't provide scope force <body> as scope

    // If no arguments given, notify and return
    if (arguments.length === 0) {
      console.error('Error: No parameters provided to $.fn.elproduct(). You must at least have a specified \'target class\' to search for. Returning now.');
    } else {
      // assign arguments and carry out internal functions
      Array.prototype.slice.call(arguments).forEach(function(argument) {
        switch (typeof argument) {
          case 'function':
            console.error('Warning: A function has been passed in the parameters, onSuccess and onError callbacks need to be part of the object and not separate.');
            break;
          case 'object': // Settings
            settings = argument;
            break;
          case 'undefined': // Ignore undefined
            break;
          case 'string': // Ignore undefined
            break;
          default: // Ignore others
            break;
        }
      });
    }

    // create extended object, assign needed values before running functions.
    extended_object = $.extend(true, {}, $.fn.elproduct.defaults, settings);
    extended_object.wrappers = $targets;

    // debug flag check
    if (typeof extended_object.debug !== 'boolean' || typeof extended_object.debug === 'undefined') {
      extended_object.debug = false;
    }

    // check if the query is okay in the event it is user supplied (usually will never be, though)
    if (typeof extended_object.query !== 'undefined') {
      try {
        JSON.parse(JSON.stringify(extended_object.query));
      } catch (e) {
        if (extended_object.debug) {
          console.error('Error: User-supplied JSON Query is malformed, or another error concerning the query has occurred. Query cannot be performed. Returning now.');
        }
        return $targets;
      }
    }

    // notify
    if (extended_object.debug) {
      console.log('Main elproduct() call');
      console.log($targets);
      console.log(extended_object);
    }

    // create the cloned list items (derived from provided template) per carousel if no li's present.
    methods._create_list_items(extended_object);

    // gather the product IDs from the li's, these will be tossed into the JSON RPC that runs
    methods._generate_product_list($targets, extended_object);

    // Gather product IDs from extended_object.prodArray and put them into productMap
    // This is for manually gathered product IDs
    extended_object.prodArray.forEach(function(product) {
      extended_object.productMap[product] = {};
    });

    if (extended_object.debug) {
      console.log('product map', extended_object.productMap);
    }

    // If page_data exists attempt to load in product data based off of such, before running the plugin's main functionality
    // Left over products should be handled after this
    (function() {
      var customMPP;
      var productsData;
      var data = [];
      var missingProductData = true;
      var extendedObjectClone = $.extend(true, {}, extended_object);

      if (extended_object.debug) {
        console.log('elproduct: Looking for page_data global variable:', typeof page_data !== 'undefined');
      }

      // Verify that page_data (global var) exists, then if custom-mpp exists
      // Then push in productsData based on that
      if (typeof page_data !== 'undefined') {
        customMPP = page_data['custom-mpp'];

        if (extended_object.debug) {
          console.log('elproduct: Looking for page_data customMPP:', typeof customMPP !== 'undefined');
        }

        if (typeof customMPP !== 'undefined') {
          productsData = customMPP['products'];

          // add singular product data to data array
          productsData.forEach(function(product) {
            data.push(product);

            extended_object.productMap[product.productID] = product;
          });
        }
      }

      // Verify if productMap has any empty entries
      // Usually means a query needs to happen
      missingProductData = Object.keys(extended_object.productMap).every(function(productID) {
        return Object.keys(extended_object.productMap[productID]).length === 0;
      });

      // Not missing anything
      if (data.length !== 0 && !missingProductData) {
        // spoof like we only have prod IDs provided and pass all empty SKUs
        data.forEach(function() {
          extendedObjectClone.skuArray.push('');
        });

        // Spoof query success
        methods._post_query_insertion(extendedObjectClone, [{
          result: {
            value: {
              products: data
            }
          }
        }]);
      } else if (Object.keys(extended_object.productMap).length > 0) {
        // Otherwise query via JSONRPC
        methods._query(extended_object);
      // If there are no product IDs, fire onError
      } else {
        if (typeof extended_object.onError === 'function') {
          extended_object.onError();
        }
      }
    }());
    return $targets;
  };

  /**
  * The default configuration, and available options to configure with.
  *
  * @name $.fn.elproduct.defaults
  * @namespace
  * @property {string} [rpc_url=/rpc/response.tmpl?JSONRPC=] The full URL that we send a GET request to.
  * @property {string} [plugin_name=jquery.elproduct] The plugin name.
  * @property {object} [map={}] A mapping for all the classes referenced, updated within the carousel/scope.
  */
  $.fn.elproduct.defaults = {
    rpc_url: '/rpc/response.tmpl?JSONRPC=',
    prodArray: [],
    skuArray: [],
    productMap: {},
    wrappers: [],
    callback: function() {},
    plugin_name: 'jquery.elproduct',
    target: '.el-product',
    // Note: This needs to be overwritten
    map: {
      'PROD_RGN_NAME': [
        {
          selector: '.el-product_name',
          targets: ['html']
        },
        {
          selector: '.el-product_image-container, a',
          targets: ['title']
        }
      ],
      'PROD_RGN_SUBHEADING': [
        {
          selector: '.el-product_rgn-subheading',
          targets: ['html']
        }
      ],
      'ATTRIBUTE_DESC_1': [
        {
          selector: '.el-product_alt_description-text',
          targets: ['html']
        }
      ],
      'PRODUCT_DETAILS_MOBILE': [
        {
          selector: '.el-product_description-text',
          targets: ['html']
        }
      ],
      'LARGE_IMAGE': [
        {
          selector: '.el-product_image',
          targets: ['src']
        }
      ],
      'formattedPrice': [
        {
          selector: '.el-product_price',
          targets: ['html']
        }
      ],
      'url': [
        {
          selector: 'a',
          targets: ['href']
        }
      ],
      'AVERAGE_RATING': [
        {
          selector: '.el-product_stars-rating span',
          targets: ['html', 'title']
        },
        {
          selector: '.el-product_stars-rating span',
          targets: ['class'],
          modifier: function(data) {
            if (typeof data !== 'number') {
              return 'rating_0_0';
            }

            return 'rating_' + data.toFixed(1).replace('.', '_');
          }
        }
      ],
      'TOTAL_REVIEW_COUNT': [
        {
          selector: '.el-product_review-count',
          targets: ['html']
        }
      ],
      'ATTRIBUTE_COLLECTION': [
        {
          selector: '.el-product_category',
          targets: ['html']
        }
      ],
      'SHADENAME': [
        {
          selector: '.el-product_shadename',
          targets: ['html']
        }
      ],
      'HEX_VALUE_STRING': [
        {
          selector: '.el-product_shadename',
          targets: ['data-swatch-color']
        }
      ]
    },
    query: [{
      method: 'prodcat.querykey',
      params: [{
        query_key: 'tout-mpp-product',
        products: []
      }]
    }]
  };

  // External function aliases
  $.elproduct = $.fn.elproduct;
})(jQuery);
